import APIKit from '../Allapis/Apikit/apikit'

export const getLocationsServer = async id => {
  const endpoint = id
    ? `/promotions/getLocations/${id}`
    : `/promotions/getLocations`
  const res = await APIKit.get(endpoint)
  return res.data
}

export const createAndUpdateLocationsServer = async (id, values) => {
  let res
  if (id) {
    res = await APIKit.post(`/promotions/${id}`, values)
  } else {
    res = await APIKit.post(`/promotions/`, values)
  }
  return res.data
}
export const deleteLocationsServer = async del_id => {
  const res = await APIKit.put(`/promotions/${del_id}`)
  return res.data
}
